import { motion } from "framer-motion";
import { Users, Briefcase, Plane, Globe, Route } from "lucide-react";

const services = [
  {
    icon: Users,
    title: "Employee Transportation",
    desc: "Safe, punctual daily commutes for your teams — planned around shifts, routes and locations.",
  },
  {
    icon: Briefcase,
    title: "Corporate Rides",
    desc: "On-demand and scheduled rides for meetings, client visits and executive travel.",
  },
  {
    icon: Plane,
    title: "Airport Transfers",
    desc: "Reliable pickups and drop-offs coordinated with flight schedules, for staff and guests.",
  },
  {
    icon: Globe,
    title: "Business Travel",
    desc: "Ground transport for intercity trips, events and multi-day business travel programs.",
  },
  {
    icon: Route,
    title: "Transport Management",
    desc: "Vendor coordination, route planning, scheduling and reporting — handled for you end to end.",
  },
];

const Services = () => (
  <section data-testid="services-section" className="py-24 md:py-32 bg-white border-y border-stone-200">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl"
      >
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-stone-900">
          What can we help with?
        </h2>
        <p className="mt-4 text-base text-stone-600 leading-relaxed">
          Every solution is tailored to your company&rsquo;s size, locations and transportation needs.
        </p>
      </motion.div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-6">
        {services.map((s, i) => (
          <motion.div
            key={s.title}
            data-testid={`service-card-${i + 1}`}
            className={`${i < 3 ? "md:col-span-4" : "md:col-span-6"} bg-white rounded-2xl border border-stone-200 p-8 shadow-sm hover:shadow-md hover:border-orange-200 transition-[border-color,box-shadow] duration-300`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.08 }}
          >
            <div className="w-11 h-11 rounded-xl bg-orange-50 border border-orange-100 flex items-center justify-center">
              <s.icon className="w-5 h-5 text-orange-600" strokeWidth={1.8} />
            </div>
            <h3 className="mt-5 text-lg font-semibold text-stone-900">{s.title}</h3>
            <p className="mt-2 text-sm text-stone-600 leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
